import AircraftDescription from './AircraftDescription';
export default AircraftDescription;
